import styled from 'styled-components'
import { Toolbar as ToolbarBase } from '@material-ui/core'

export const Toolbar = styled(ToolbarBase)`
  display: flex;
  justify-content: space-between;
  & svg {
    color: #fff;
  }
`
